<div class="irembogov-field-diff-viewer">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center">
      <h6 class="mb-0 me-2" *ngIf="sectionTitle">{{ sectionTitle }}</h6>
      <span class="badge bg-info" *ngIf="changedCount > 0">
        {{ changedCount }} change{{ changedCount > 1 ? 's' : '' }}
      </span>
      <span class="badge bg-secondary" *ngIf="changedCount === 0">
        No changes
      </span>
    </div>
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="showUnchangedFields"
        [(ngModel)]="showUnchanged" />
      <label class="form-check-label small" for="showUnchangedFields">
        Show unchanged
      </label>
    </div>
  </div>

  <table
    class="table table-sm table-bordered"
    *ngIf="getVisibleDiffs().length > 0">
    <thead class="table-light">
      <tr>
        <th class="w-25">Field</th>
        <th class="w-25">Active (Current Live)</th>
        <th class="w-25">New (Change Request)</th>
        <th class="w-25 text-center">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let field of getVisibleDiffs()"
        [ngClass]="{
          'field-added': field.changeType === 'added',
          'field-removed': field.changeType === 'removed',
          'field-modified': field.changeType === 'modified',
          'field-unchanged': field.changeType === 'unchanged'
        }">
        <td class="fw-medium">{{ getFieldLabel(field) }}</td>
        <td>
          <pre class="mb-0 field-value" *ngIf="field.oldValue !== undefined">{{
            formatValue(field.oldValue)
          }}</pre>
          <span class="text-muted" *ngIf="field.oldValue === undefined"
            >(not set)</span
          >
        </td>
        <td>
          <pre class="mb-0 field-value" *ngIf="field.newValue !== undefined">{{
            formatValue(field.newValue)
          }}</pre>
          <span class="text-muted" *ngIf="field.newValue === undefined"
            >(not set)</span
          >
        </td>
        <td class="text-center">
          <span
            class="badge"
            [ngClass]="{
              'bg-success': field.changeType === 'added',
              'bg-danger': field.changeType === 'removed',
              'bg-warning text-dark': field.changeType === 'modified',
              'bg-light text-muted': field.changeType === 'unchanged'
            }">
            {{ field.changeType }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <div
    class="text-center text-muted py-3"
    *ngIf="getVisibleDiffs().length === 0 && !showUnchanged">
    All fields are unchanged.
    <a href="javascript:void(0)" (click)="showUnchanged = true"
      >Show all fields</a
    >
  </div>
</div>
